import React, { useEffect } from "react";
import { SIcon, SInput, SPage, SText, STheme, SThread, SView } from "servisofts-component";
// import MDL from "../../../MDL";
import ToolTips from "../../../Components/ToolTips";
import Model from "../../../Model";
// import SIconApp from "../../../Assets/SIconApp";

export default class PuntoDeVentaChoise extends React.Component {
    state: any = {
        selects: [],
    };

    onAdd = (sucursal) => {
        // Agregar la sucursal a sucursales del item
      
        if (this.props.onAdd) this.props.onAdd(sucursal);
        this.forceUpdate();
    };

    onDelete = (key) => {
        console.log("key__", key)
       

        if (this.props.onDelete) this.props.onDelete(key);
        this.forceUpdate();
    };

    render() {
        console.log("ALL", this.props.all)
        console.log("DATA", this.props.data)
        const sucursales = Object.values(this.props.sucursales);

        return (
            <SView row>
                {/* tags elegidas */}
                {this.props.all.sucursales.map((k) => {
                    const suc = sucursales.find(s => s.key === k);
                    if (!suc) return null;
                    return (
                        <Tag
                            key={k}
                            label={suc.descripcion}
                            onDelete={() => this.onDelete(k)}
                        />
                    );
                })}
               {/* select sucursal */}
                <TagInput
                    data={sucursales}
                    selected={this.props.all.sucursales}
                    onAdd={this.onAdd}
                />
            </SView>
        );
    }
}



const Tag = ({ label, onDelete }) => {
    const color = STheme.colorFromText(label)
    return <SView style={{
        borderWidth: 1,
        borderRadius: 4,
        borderColor: color,
        backgroundColor: color + "44",
        padding: 2,
        paddingHorizontal: 4,
        margin: 1,
        justifyContent: "center",
        alignItems: "center"
    }} row onPress={onDelete}>
        <SText clean style={{
            fontSize: 10,
        }}>{label}</SText>
        <SView width={4} />
        <SView width={12} height={12}>
            <SIcon name="Close" fill={STheme.color.text} />
        </SView>
    </SView>
}


const TagInput = ({ onAdd, data, selected }) => {
    const inputRef = React.useRef<SInput>(null);

    return (
        <SView>
            <SInput
                ref={inputRef}
                type="select2"
                height={20}
                width={160}
                placeholder="Hab. Punto de venta..."
                options={data
                    .filter(s => !selected.includes(s.key))
                    .map(s => s.descripcion)
                }
                onChangeText={e => {
                    const descripcion = e;  
                    const suc = data.find(s => s.descripcion === descripcion);

                    console.log("descripcion", descripcion);
                    console.log("suc encontrada:", suc);

                    if (suc) {
                        onAdd(suc.key);
                        if (inputRef.current) {
                            console.log("INPUT", inputRef)
                            inputRef.current.setValue("Elige una sucursal...");
                        }
                    }
                }}
                onBlur={() => {
                    // const descripcion = inputRef.current.getValue();  // texto, no key
                    // const suc = data.find(s => s.descripcion === descripcion);

                    // console.log("descripcion", descripcion);
                    // console.log("suc encontrada:", suc);

                    // if (suc) {
                    //     onAdd(suc);
                    //     inputRef.current.setValue("");
                    // }
                }}
            />
        </SView>
    );
};
